import Vue from 'vue'
import VueRouter from 'vue-router'

import Register from '@/pages/register'
import RegistrationUpdate from '@/pages/registrationUpdate'
import Confirm from '@/pages/confirm'
import ConfirmPhone from '@/pages/confirmPhone'
import Login from '@/pages/login'
import Application from '@/pages/recruitment/application'
import HoldingPage from '@/pages/holdingPage'
import CalendarPhone from '@/pages/calendar/calendarPhone'
import CalendarFTF from '@/pages/calendar/calendarFTF'
import Onboarding from '@/pages/recruitment/onboarding'
import ApplicationSubmitSuccess from '@/pages/applicationSubmitSuccess'
import PasswordReset from '@/pages/passwordReset'
import Ethnic from '@/pages/ethnicity'
import Reference from '@/pages/reference'

Vue.use(VueRouter)

export default new VueRouter({
  routes: [
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
      meta: {
        requiresGuest: true,
      },
    },
    {
      path: '/registration-update',
      name: 'registrationUpdate',
      component: RegistrationUpdate,
      meta: {
        requiresGuest: true,
      },
    },
    {
      path: '/password-reset',
      name: 'passwordReset',
      component: PasswordReset,
      meta: {
        requiresGuest: true,
      },
    },
    {
      path: '/confirm',
      name: 'confirm',
      component: Confirm,
      meta: {
        // requiresAuth: true
      },
    },
    {
      path: '/confirm-phone',
      name: 'confirmPhone',
      component: ConfirmPhone,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        requiresGuest: true,
      },
    },
    {
      path: '/application',
      name: 'application',
      component: Application,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/application/ethnicity',
      name: 'ethnic',
      component: Ethnic,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/application/submit-success',
      name: 'applicationSubmitSuccess',
      component: ApplicationSubmitSuccess,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/holding',
      name: 'holding-page',
      component: HoldingPage,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/calendar-phone',
      name: 'calendarPhone',
      component: CalendarPhone,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/calendar-ftf',
      name: 'calendarFTF',
      component: CalendarFTF,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/onboarding',
      name: 'onboarding',
      component: Onboarding,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/reference/:id',
      name: 'reference',
      component: Reference,
    },
  ],
})
